(() => {
  const MINI_STARS_WIDGET_ID = 'wdg-997c0045-f0b3-43d9-a0ae-96cf02e41b92';
  const REVIEW_LIST_WIDGET_ID = 'wdg-68e2f0f3-0d18-466c-80b8-89b23d807182';
  const STAR_CONTAINER_ID = 'etrusted-product_star';
  const WIDGET_TAG = 'etrusted-widget';
  const PRODUCT_REVIEWS_PATH = '/feeds/product-reviews/';
  const APP_BLOCK_SELECTOR = '.shopify-block.shopify-app-block';
  const SECTION_SELECTOR = '.shopify-section';
  const CLICK_THRESHOLD_MS = 300;

  const widgetSelector = (id) => `${WIDGET_TAG}[data-etrusted-widget-id="${id}"]`;
  const getWrapper = (el) => el.closest(APP_BLOCK_SELECTOR) || el.parentElement || el;

  function parseSkuList(value) {
    return String(value || '')
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
  }

  function skuFromUrl(url) {
    try {
      const u = new URL(url, location.href);
      return (
        u.searchParams.get('sku') ||
        u.searchParams.get('productSku') ||
        u.searchParams.get('product_sku') ||
        u.searchParams.get('productId') ||
        u.searchParams.get('product_id')
      );
    } catch {
      const m = String(url).match(/(?:sku|productSku|product_sku|productId|product_id)=([^&]+)/i);
      return m ? decodeURIComponent(m[1]) : null;
    }
  }

  function pickNumber(v) {
    if (v == null) return null;
    const n = typeof v === 'string' ? Number(v) : v;
    return Number.isFinite(n) ? n : null;
  }

  function hasNoReviews(data) {
    if (Array.isArray(data)) return data.length === 0;

    const reviewCount =
      pickNumber(data?.reviewCount) ??
      pickNumber(data?.ratingCount) ??
      pickNumber(data?.totalCount) ??
      pickNumber(data?.count) ??
      pickNumber(data?.aggregateRating?.reviewCount) ??
      pickNumber(data?.aggregateRating?.ratingCount);

    if (reviewCount === 0) return true;
    if (Array.isArray(data?.reviews) && data.reviews.length === 0) return true;
    if (Array.isArray(data?.items) && data.items.length === 0) return true;

    return false;
  }

  function hideWidget(widgetId, sku) {
    document.querySelectorAll(widgetSelector(widgetId)).forEach((el) => {
      if (sku && el.hasAttribute('data-sku')) {
        const list = parseSkuList(el.getAttribute('data-sku'));
        if (!list.includes(String(sku))) return;
      }

      getWrapper(el).style.display = 'none';
    });
  }

  function hideNoReviewsUI(sku) {
    hideWidget(MINI_STARS_WIDGET_ID, sku);
    hideWidget(REVIEW_LIST_WIDGET_ID, sku);
  }

  function hideNoReviewsFallback() {
    hideWidget(MINI_STARS_WIDGET_ID, null);
    hideWidget(REVIEW_LIST_WIDGET_ID, null);
  }

  function extractSku(url, data) {
    return (
      skuFromUrl(url) ||
      data?.sku ||
      data?.product?.sku ||
      data?.productSku ||
      data?.product?.productSku
    );
  }

  function handleNoReviews(url, data) {
    if (!hasNoReviews(data)) return;
    const sku = extractSku(url, data);
    if (sku) hideNoReviewsUI(sku);
    else hideNoReviewsFallback();
  }

  async function handleJsonResponse(url, res) {
    try {
      const clone = res.clone();
      const ct = (clone.headers.get('content-type') || '').toLowerCase();
      if (!ct.includes('application/json')) return;
      handleNoReviews(url, await clone.json());
    } catch {}
  }

  function isProductReviewsUrl(url) {
    return String(url || '').includes(PRODUCT_REVIEWS_PATH);
  }

  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input?.url || '');
    const p = origFetch.apply(this, arguments);

    p.then((res) => {
      if (isProductReviewsUrl(url)) handleJsonResponse(url, res);
    }).catch(() => {});

    return p;
  };

  const OrigXHR = window.XMLHttpRequest;
  window.XMLHttpRequest = function () {
    const xhr = new OrigXHR();
    let _url = '';

    const origOpen = xhr.open;
    xhr.open = function (method, url) {
      _url = String(url || '');
      return origOpen.apply(this, arguments);
    };

    xhr.addEventListener('load', () => {
      try {
        if (!isProductReviewsUrl(_url)) return;

        const ct = (xhr.getResponseHeader('content-type') || '').toLowerCase();
        if (!ct.includes('application/json')) return;

        handleNoReviews(_url, JSON.parse(xhr.responseText));
      } catch {}
    });

    return xhr;
  };

  function findReviewListSection() {
    const widget = document.querySelector(widgetSelector(REVIEW_LIST_WIDGET_ID));
    return widget ? widget.closest(SECTION_SELECTOR) || widget.closest('section') : null;
  }

  function scrollToReviews() {
    const target = findReviewListSection();
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function isInsideRect(x, y, rect) {
    return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
  }

  function setupJumpLink() {
    const container = document.getElementById(STAR_CONTAINER_ID);
    if (!container || container.dataset.jumpLinked) return;
    container.dataset.jumpLinked = 'true';
    container.style.display = 'inline-block';

    const widget = container.querySelector(WIDGET_TAG);
    if (widget) {
      widget.style.cursor = 'pointer';
    }

    let downTime = 0;

    document.addEventListener('pointerdown', (e) => {
      if (isInsideRect(e.clientX, e.clientY, container.getBoundingClientRect())) {
        downTime = Date.now();
      }
    }, true);

    document.addEventListener('pointerup', (e) => {
      if (!downTime) return;
      const elapsed = Date.now() - downTime;
      downTime = 0;
      if (elapsed < CLICK_THRESHOLD_MS && isInsideRect(e.clientX, e.clientY, container.getBoundingClientRect())) {
        scrollToReviews();
      }
    }, true);
  }

  new MutationObserver(() => {
    if (document.getElementById(STAR_CONTAINER_ID)) {
      setupJumpLink();
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
